import * as React from 'react'
import * as Api from 'src/api'
import { useDebouncedLoadOptions } from 'src/helpers/hooks'
import { type AuthenticatedHeaders } from 'src/hooks/auth/app'
import AsyncSelectInput from 'src/views/components/forms/formik/AsyncSelectInput'
import { type Option } from 'src/views/components/forms/formik/SelectInput'
import { programsListToOptions } from './mapModels'
import { type ProgramCodesFieldName } from './types'

export function ProgramCodesSelectField({
  name,
  label,
  headers,
  degree,
}: {
  readonly name: ProgramCodesFieldName
  readonly label: string
  readonly headers: AuthenticatedHeaders
  readonly degree?: string
}): JSX.Element {
  const loadOptions = useDebouncedLoadOptions<Option>(
    React.useCallback(
      async (q: string) => {
        const result = await Api.getAdministratorListsPrograms({
          headers,
          query: {
            q,
            status: 1,
            ...(degree != null && degree !== '' ? { degree: Number.parseInt(degree, 10) } : {}),
          },
        })
        return programsListToOptions(result.data)
      },
      [headers, degree]
    ),
    { skipEmpty: true }
  )

  return (
    <AsyncSelectInput
      name={name}
      label={label}
      isMulti
      storeValueOnly
      closeMenuOnSelect={false}
      cacheOptions
      loadOptions={loadOptions}
      placeholder={label}
    />
  )
}
